import { usePage } from '@inertiajs/react'
import { t } from '@/shared/lib/i18n'
import type { SharedProps } from '@/shared/types/SharedProps'

const ImpersonationBanner = () => {
  const { impersonationBanner } = usePage<SharedProps>().props

  if (!impersonationBanner) return null

  const csrfToken =
    document.head.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? ''

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2 text-sm text-amber-900">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 sm:px-6">
        <span>
          {t('impersonationBanner.label')} <strong>{impersonationBanner.userName}</strong> (
          {impersonationBanner.userEmail})
        </span>
        <form method="post" action={impersonationBanner.stopPath}>
          <input type="hidden" name="_method" value="delete" />
          <input type="hidden" name="authenticity_token" value={csrfToken} />
          <button
            type="submit"
            className="shrink-0 rounded border border-amber-400 bg-amber-100 px-2.5 py-1 text-xs font-medium text-amber-900 hover:bg-amber-200"
          >
            {t('impersonationBanner.stopButton')}
          </button>
        </form>
      </div>
    </div>
  )
}

export default ImpersonationBanner
